class HeaderNavigationService {
    /*@ngInject*/
    constructor($log, $http, $rootScope) {
        this.$log = $log;
        this.$http = $http;
        this.$rootScope = $rootScope;
        this.loginResponse = null;
    }

    submitLogin(url, usr, pwd, rememberme, reload) {
        let req = {
            method: 'POST',
            url: url,
            data: {
                loginForm: {
                    j_username: usr,
                    j_password: pwd
                }
            }
        };

        this.$http(req).then((response) => {
            this.loginResponse = response.data;
            if (reload && this.loginResponse.success) {
                window.location.reload();
            } else {
                this.$rootScope.$broadcast('submitLoginFinished');
            }
        }, (error) => {
            this.$log.error("Error at Login");
        });
    }

    getLoginResponse() {
        return this.loginResponse;
    }
}

export default HeaderNavigationService;
